import { defineComponent as _defineComponent } from 'vue';
import { useRouter } from "vue-router/composables";
import Popper from "@/components/Popper/Popper.vue";
import TextShort from "@/components/Common/TextShort.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActivityItem',
    props: {
        id: null,
        title: { default: undefined },
        icon: { default: "question" },
        indicator: { default: 0 },
        isActive: { type: Boolean, default: false },
        tooltip: { default: undefined },
        tooltipPlacement: { default: "right" },
        progressPercentage: { default: 0 },
        progressStatus: { default: undefined },
        options: { default: undefined },
        to: { default: undefined }
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const props = __props;
        const router = useRouter();
        function onClick(evt) {
            emit("click");
            if (props.to) {
                router.push(props.to);
            }
        }
        return { __sfc: true, router, props, emit, onClick, Popper, TextShort, FontAwesomeIcon };
    }
});
